import React, { useState, useEffect } from 'react';
import { fetchUserPosts } from '../../services/api'; // Use user posts API
import BreakingNewsBanner from '../widgets/BreakingNewsBanner';

const AllUserPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 10;

    useEffect(() => {
        const getPosts = async () => {
            try {
                const fetchedPosts = await fetchUserPosts();
                setPosts(fetchedPosts);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch user-published articles.');
            } finally {
                setLoading(false);
            }
        };

        getPosts();
    }, []);

    if (loading) return <div className="text-center mt-5">Loading articles...</div>;
    if (error) return <div className="text-center mt-5 text-danger">{error}</div>;
    if (!posts.length) return <div className="text-center mt-5">No articles available</div>;

    // Pagination logic
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(posts.length / postsPerPage);

    return (
        <div className="container mt-1">
            <BreakingNewsBanner />
            <h1 className="mb-4 text-center fw-bold">Stories from Fellow Jesssters</h1>
            <div className="d-flex justify-content-center">
                <div className="list-group" style={{ width: '75%' }}>
                    {currentPosts.map((post) => (
                        <a
                            key={post.id}
                            href={`/user-posts/${post.slug}`}  // <-- user post URL
                            className="list-group-item list-group-item-action d-flex flex-column flex-md-row align-items-start align-items-md-center mb-4"
                            style={{ transition: 'background-color 0.3s ease', width: '100%' }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5E7EB'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = ''}
                        >
                            <img
                                src={`https://res.cloudinary.com/dbm8xbouw/${post.featured_image}`}
                                alt={post.title}
                                className="img-thumbnail d-block d-md-inline mx-auto mx-md-0 me-md-3"
                                style={{ width: '150px', height: 'auto' }}
                                onError={(e) => e.currentTarget.src = 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736181865/web_development___website_webpage_browser_ad_advertisement_man_people_ibpgaq.png'}
                            />
                            <div>
                                <h5 className="mb-3" style={{ fontWeight: 'bold' }}>{post.title}</h5>
                                <p className="mb-1 text-muted">{post.excerpt || 'No description available'}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-center mt-4">
                <button
                    className="btn btn-dark me-2 fw-bold"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    Previous
                </button>
                <span className="align-self-center fw-bold px-3">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    className="btn btn-dark ms-2 fw-bold"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default AllUserPosts;
